import RelatedProductItem from './RelatedProductItem';
export default RelatedProductItem; 